import { render, staticRenderFns } from "./NsrItemModuleTenderRates.vue?vue&type=template&id=ecd3bd9a"
import script from "./NsrItemModuleTenderRates.vue?vue&type=script&lang=js"
export * from "./NsrItemModuleTenderRates.vue?vue&type=script&lang=js"
import style0 from "./NsrItemModuleTenderRates.vue?vue&type=style&index=0&id=ecd3bd9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports